import React from 'react';
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
`;

const pulseFrames = keyframes`
  50% {
    opacity: 0.2;
    transform: scale(0.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const BeatLoader = styled.div`
  > div {
    background-color: rgb(71, 145, 219);
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 2px;
    animation-fill-mode: both;
    display: inline-block;
    animation: ${pulseFrames} 0.7s 0s infinite linear;
    &:nth-child(2n-1) {
      animation-delay: -0.35s !important;
    }
  }
`;

const MessageContainer = styled.div`
  color: white;
  white-space: pre-line;
  text-align: center;
`;

export default () => {
  const { message } = useSelector(state => state.progress);
  return (
    <LoaderWrapper id="do-test-loader">
      <BeatLoader>
        <div />
        <div />
        <div />
      </BeatLoader>
      {message && (
        <MessageContainer className="message">{message}</MessageContainer>
      )}
    </LoaderWrapper>
  );
};
